import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
//import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import * as YUKA from 'yuka'
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils'

/**
 * Base
 */
// Debug

const debugObject = {}

const gui = new dat.GUI()






//const renderer = new THREE.WebGL1Renderer({ antialias: true });
//renderer.setSize(window.innerWidth, window.innerHeight);
//document.body.appendChild(renderer.domElement)


// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


//renderer.setClearColor(0xA3A3A3);




/**
 * Models
 */
//const dracoLoader = new DRACOLoader()
//dracoLoader.setDecoderPath('/draco/')

//const gltfLoader = new GLTFLoader()
//gltfLoader.setDRACOLoader(dracoLoader)



/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.8)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(- 5, 5, 0)
scene.add(directionalLight)


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})


/**
 * Camera
 */
// Base camera


const camera = new THREE.PerspectiveCamera(
    45,
    window.innerWidth / window.innerHeight,
    0.1,
    1000
);

camera.position.set(0, 30, 0);
camera.lookAt(scene.position);





// Controls
//const controls = new OrbitControls(camera, canvas)
//controls.target.set(0, 0.75, 0)
//controls.enableDamping = true






const vehicleGeometry = new THREE.ConeGeometry(0.1, 0.2, 3)
vehicleGeometry.rotateX(Math.PI * 0.5);
const vehicleMaterial = new THREE.MeshBasicMaterial( { color: '#ffdf00'});



const entityManager2 = new YUKA.EntityManager();

//function sync(entity, setRenderComponent) {
//    setRenderComponent.matrix.copy(entity.worldMatrix)

//}















const entityManager = new YUKA.EntityManager();

function sync(entity, setRenderComponent) {
    setRenderComponent.matrix.copy(entity.worldMatrix);
}






for(let i = 0; i < 25; i++){
    const vehicleMesh = new THREE.Mesh(vehicleGeometry, vehicleMaterial)
    //vehicleMesh.material = new THREE.MeshBasicMaterial( { color: 0xf124ff } );
    vehicleMesh.matrixAutoUpdate = false;
    scene.add(vehicleMesh);

    const vehicle = new YUKA.Vehicle();
    vehicle.setRenderComponent(vehicleMesh, sync);

    const wanderBehavior = new YUKA.WanderBehavior();
    vehicle.steering.add(wanderBehavior);

    entityManager.add(vehicle);


    vehicle.position.x = 2.5 - Math.random() * 35 + 15;
    vehicle.position.y = 2.5 - Math.random() * 15;
    vehicle.position.z = 2.5 - Math.random() * 35 + 15;

    const randomscale1 = Math.random() + 0.2
    vehicle.scale.set(randomscale1, randomscale1, randomscale1)
    vehicle.rotation.fromEuler(0, 2 * Math.PI * Math.random(), 0);
}








const loader = new GLTFLoader();
let fishmixer;
let mixer;

const yellowMaterial = new THREE.MeshStandardMaterial( { color: '#FFDF00', side: THREE.DoubleSide } );
const orangeMaterial = new THREE.MeshStandardMaterial( { color: '#EC9700', side: THREE.DoubleSide } );


loader.load('./models/Triangle/triangle sphere4_fish_baked.glb', function(glb) {
    const modelfish = glb.scene;
    
    
   // console.log(modelfish)
  //  modelfish.child.material = new THREE.MeshBasicMaterial( { color: 0xf124ff } );


    glb.scene.traverse((child) =>
    {
     //   console.log(child)
 //       child.material = new THREE.MeshBasicMaterial( { color: 0xf124ff } );
    })

    const fish_frontMesh = glb.scene.children.find((child) => child.name === 'fish_front')
    const fish_middleMesh = glb.scene.children.find((child) => child.name === 'fish_middle')
    const fish_backMesh = fish_middleMesh.children.find((child) => child.name === 'fish_back')



    fish_frontMesh.material = orangeMaterial;
    fish_middleMesh.material = yellowMaterial;

    fish_backMesh.material = orangeMaterial;

   // const clips = glb.animations;
    const fishes = new THREE.AnimationObjectGroup();
    

   // mixer = new THREE.AnimationMixer(fishes);

  //  const clip = THREE.AnimationClip.findByName(clips, 'fish front', 'fish');
   // const action = mixer.clipAction(clip);
   
    

    fishmixer = new THREE.AnimationMixer(fishes)

    const fishclips = glb.animations;
    

    fishclips.forEach( function ( clip ) {
        fishmixer
        .clipAction( clip )
        .setLoop(THREE.LoopPingPong)
        .play();
    } );




    
   // console.log(fishclips)



    for(let i = 0; i < 15; i++) {
        //const vehicleMesh = new THREE.Mesh(vehicleGeometry, vehicleMaterial);
        //modelfish.rotateY(Math.PI * 3);
        const fishClone = SkeletonUtils.clone(modelfish);
        fishClone.matrixAutoUpdate = false;
        
        scene.add(fishClone);
        fishes.add(fishClone);
        fishClone.scale.set(0.25, 0.25, 0.25)
        const vehicle = new YUKA.Vehicle();
        vehicle.setRenderComponent(fishClone, sync);
    
    
        const wanderBehavior = new YUKA.WanderBehavior();
        vehicle.steering.add(wanderBehavior);
    
        entityManager.add(vehicle);
    
        const randomscale2 = Math.random() + 0.4
        vehicle.scale.set(randomscale2, randomscale2, randomscale2)
        vehicle.position.x = 2.5 - Math.random() * 35 + 15;
        vehicle.position.y = 2.5 - Math.random() * 5;
        vehicle.position.z = 2.5 - Math.random() * 35 + 15;
        vehicle.rotation.fromEuler(0, 2 * Math.PI * Math.random(), 0);
    
    
    }


});








/**
 * Models
 */

//const dracoLoader = new DRACOLoader()
//dracoLoader.setDecoderPath('/draco/')

const gltfLoader = new GLTFLoader()
//gltfLoader.setDRACOLoader(dracoLoader)

//let mixer = null
//const clips = mesh.animations;

var model;

const blueMaterial = new THREE.MeshStandardMaterial({ color: '#5E7CF7', side: THREE.DoubleSide })
//const yellowMaterial = new THREE.MeshStandardMaterial({ color: '#FFDF00', side: THREE.DoubleSide })
const transparentMaterial = new THREE.MeshBasicMaterial()

gltfLoader.load(
    './models/Triangle/triangle sphere10_baked.glb',
    (gltf) =>
    {
        const blueTriangleMesh = gltf.scene.children.find((child) => child.name === 'plane_blue_triangle')
        blueTriangleMesh.traverse((child) =>
        {
            //     if ( child instanceof plane_blue_triangle ) { 
                     child.material = blueMaterial;
              //   console.log(child)
             })

        const yellowTriangleMesh = gltf.scene.children.find((child) => child.name === 'plane_yellow_triangle')
        yellowTriangleMesh.traverse((child) =>

        {
       //     if ( child instanceof plane_blue_triangle ) { 
                child.material = yellowMaterial;
         //   console.log(child)
        })

        
        
        const imageTriangleMesh = gltf.scene.children.find((child) => child.name === 'plane_image_triangle')

    

        console.log(blueTriangleMesh)


 
        blueTriangleMesh.material = orangeMaterial;


        

        gltf.scene.scale.set(1, 1, 1)
        model = gltf.scene;
        scene.add(model)
        model.position.y = 20;
        
    
        //console.log(model)

        // Animation
        mixer = new THREE.AnimationMixer(model)

        const clips = gltf.animations;
        

        clips.forEach( function ( clip ) {
            mixer
            .clipAction( clip )
            .setLoop(THREE.LoopPingPong)
            .play();
        } );

        
        
        
        console.log(model)

    }
)



/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
//renderer.shadowMap.enabled = true
//renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

debugObject.clearColor = '#01468c'
renderer.setClearColor(debugObject.clearColor)
renderer.outputEncoding = THREE.NoToneMapping;


/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{

    
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Model animation
    if(mixer)
    {
        mixer.update(deltaTime)
    }

    if(fishmixer)
    {
        fishmixer.update(deltaTime)
    }

if (model) model.rotation.z -= 0.002;

   // model.rotation.y = 5;

   // gltfLoader.rotation.y += 5;

    //model.rotation.y += 0.02;
    // Update controls
   // controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()











const time = new YUKA.Time();
//const clock = new THREE.Clock();



function animate() {
    const clockDelta = clock.getDelta();
    if(mixer)
        mixer.update(clockDelta);
    const delta = time.update().getDelta();
    entityManager.update(delta);
    renderer.render(scene, camera);
}

renderer.setAnimationLoop(animate);

window.addEventListener('resize', function() {
    camera.aspect = window.innerWidth / this.window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
});





//const renderer = new THREE.WebGL1Renderer({ antialias: true });
//renderer.setSize(window.innerWidth, window.innerHeight);
//document.body.appendChild(renderer.domElement)







